module.exports = __webpack_public_path__ + "img/Terra_Blade_demo.0d30078d.gif";